import React from 'react';
import { _roleType } from '@custom/Utils/constants/appConstants';
import RadiologistGraph from './RadiologistGraph';
import AdminGraph from './AdminGraph';

const GraphForm = ({ selectedYear }) => {

  const role = sessionStorage.getItem('role') || localStorage.getItem('role');
  return (
    <div>
      {(role == _roleType.radiologist || role == _roleType.pathologist) ? <RadiologistGraph selectedYear={selectedYear} /> : <AdminGraph selectedYear={selectedYear} />}
    </div>
  )
}

export default GraphForm
